import { render, staticRenderFns } from "./ListProduk.vue?vue&type=template&id=be7e7f7e"
import script from "./ListProduk.vue?vue&type=script&lang=js"
export * from "./ListProduk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports